// Vendors
import 'src/scripts/vendor/jquery'
import 'src/scripts/vendor/bootstrap'
// import 'src/scripts/modules/darkmode-handler'
import 'videojs-youtube';
import videojs from 'video.js';

// import 'flickity/dist/flickity.min.css';
// import Flickity from 'flickity';
import slick from 'slick-carousel'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// jQuery('span,p,h1,h2,h3,h4,h5,h6').each(function() {
//   var size = jQuery(this).css('fontSize').replace('px', '')
//   console.log(size)
//   size = size * .95
//   console.log(size)
//   console.log("====================")
//   jQuery(this).css('fontSize', size + "px")
// })

var myPlayer = videojs('player1');

myPlayer.on("pause", function () {
  $('#player1').removeClass('in')
});

jQuery('.play-button').on('click', function(){
  $('#player1').show();
  $('#player1').addClass('in')
  myPlayer.play();
})

jQuery('.anchor').on('click', function(e){
  e.preventDefault();

  $('html,body').animate({
    scrollTop: (jQuery(jQuery(this).attr('href')).offset().top - (jQuery('.navbar').innerHeight() * .9)) 
  })

  if(jQuery('.navbar-collapse.collapse').hasClass('show')){
    jQuery('[data-bs-toggle="collapse"]').click()
  }

  return false;
})

$(".gallery").slick({

  // normal options...
  infinite: true,

  // the magic
  // responsive: [{

  //     breakpoint: 1024,
  //     settings: {
  //       slidesToShow: 3,
  //       infinite: true
  //     }

  //   }, {

  //     breakpoint: 600,
  //     settings: {
  //       slidesToShow: 1,
  //       dots: false
  //     }

  //   }, {

  //     breakpoint: 300,
  //     settings: "unslick" // destroys slick

  //   }]
});

// var flky = new Flickity( '.gallery', {
//   // options, defaults listed

//   accessibility: true,
//   // enable keyboard navigation, pressing left & right keys

//   adaptiveHeight: false,
//   // set carousel height to the selected slide

//   autoPlay: true,
//   // advances to the next cell
//   // if true, default is 3 seconds
//   // or set time between advances in milliseconds
//   // i.e. `autoPlay: 1000` will advance every 1 second

//   cellAlign: 'center',
//   // alignment of cells, 'center', 'left', or 'right'
//   // or a decimal 0-1, 0 is beginning (left) of container, 1 is end (right)

//   cellSelector: undefined,
//   // specify selector for cell elements

//   contain: false,
//   // will contain cells to container
//   // so no excess scroll at beginning or end
//   // has no effect if wrapAround is enabled

//   draggable: '>1',
//   // enables dragging & flicking
//   // if at least 2 cells

//   dragThreshold: 3,
//   // number of pixels a user must scroll horizontally to start dragging
//   // increase to allow more room for vertical scroll for touch devices

//   freeScroll: false,
//   // enables content to be freely scrolled and flicked
//   // without aligning cells

//   friction: 0.2,
//   // smaller number = easier to flick farther

//   groupCells: false,
//   // group cells together in slides

//   initialIndex: 0,
//   // zero-based index of the initial selected cell

//   lazyLoad: false,
//   // enable lazy-loading images
//   // set img data-flickity-lazyload="src.jpg"
//   // set to number to load images adjacent cells

//   percentPosition: true,
//   // sets positioning in percent values, rather than pixels
//   // Enable if items have percent widths
//   // Disable if items have pixel widths, like images

//   prevNextButtons: true,
//   // creates and enables buttons to click to previous & next cells

//   pageDots: false,
//   // create and enable page dots

//   resize: true,
//   // listens to window resize events to adjust size & positions

//   rightToLeft: false,
//   // enables right-to-left layout

//   setGallerySize: true,
//   // sets the height of gallery
//   // disable if gallery already has height set with CSS

//   watchCSS: false,
//   // watches the content of :after of the element
//   // activates if #element:after { content: 'flickity' }

//   wrapAround: false
//   // at end of cells, wraps-around to first for infinite scrolling

// });